// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1_fLx","cls2":"NewsHeader-cls2__ss NewsHeader-cls1_fLx"};